import type { Nullable } from "vite-node"
import { ELEVATION_ABSOLUTE_MIN } from "../../../core/entity/EntityElevation/elevation_consts"
import isEntityHasElevation from "../../../core/entity/EntityElevation/isEntityHasElevation"
import isEntityHasFloorElevation from "../../../core/entity/EntityElevation/isEntityHasFloorElevation"
import type { Entity } from "../../../core/entity/index"

// I use this one for placing the meshes
export default function getTerrainMesh1TileElevationV1(ent: Nullable<Entity>): number {
  if (ent) {
    if (isEntityHasFloorElevation(ent)) {
      return ent.floor_e
    }
    if (isEntityHasElevation(ent)) {
      return ent.elevation
    }
  }
  return ELEVATION_ABSOLUTE_MIN
}